function getFileNameFromUrl(url) {
    try {
        if (!url) {
      return "";
    }
    const urlObj = new URL(url);
    const pathname = decodeURIComponent(urlObj.pathname); // Decode URL-encoded characters
    const fileNameWithTimeStamp = pathname.split('/').pop(); // Get last part of the URL
  
    return fileNameWithTimeStamp.split('__').slice(1).join("__"); // Remove timestamp
    } catch (error) {
        console.log("Url format error");
        
    }
    
  }
  
  export default getFileNameFromUrl;
  